import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { YesNoTag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import type { IncomingInvoicePaymentRunListItem } from "@msuite/utils/types";
import { UserCard } from "@/components/cards/user-card";
import { formatInvoiceAmount, formatInvoiceDate } from "@/components/incoming-invoices";
import { PaymentRunInvoicesCell } from "./payment-run-invoices-cell";
import { PaymentRunTransactionsCell } from "./payment-run-transactions-cell";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoicePaymentRunListItem>();

export const columns = [
	columnHelper.accessor("createdAt", {
		id: "createdAt",
		header: localized("incoming_invoices.payments.exported_at"),
		cell: (cell) => moment(cell.getValue()).shortFormat(),
		size: 160,
	}),
	columnHelper.accessor("executionDate", {
		id: "executionDate",
		header: localized("incoming_invoices.payments.execution_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 150,
	}),
	columnHelper.accessor("transactionCount", {
		id: "transactionCount",
		header: localized("incoming_invoices.payments.transfer_count"),
		cell: (cell) => <PaymentRunTransactionsCell transactionCount={cell.getValue()} />,
		size: 170,
	}),
	columnHelper.accessor("controlSum", {
		id: "controlSum",
		header: localized("incoming_invoices.payments.total"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), "EUR"),
		size: 140,
	}),
	columnHelper.accessor((row) => row.invoices.map((invoice) => invoice.number).join(" "), {
		id: "invoices",
		header: localized("incoming_invoices.payments.invoices"),
		cell: (cell) => <PaymentRunInvoicesCell invoices={cell.row.original.invoices} />,
	}),
	columnHelper.accessor("isSkontoApplied", {
		id: "isSkontoApplied",
		header: localized("incoming_invoices.payments.skonto_total"),
		cell: (cell) => <YesNoTag value={cell.getValue()} />,
		size: 100,
	}),
	columnHelper.accessor("format", {
		id: "format",
		header: localized("incoming_invoices.payments.format"),
		cell: (cell) => <span className="font-mono">{cell.getValue()}</span>,
		size: 160,
	}),
	columnHelper.accessor((row) => row.createdBy?.name ?? null, {
		id: "createdBy",
		header: localized("incoming_invoices.payments.exported_by"),
		cell: (cell) =>
			cell.row.original.createdBy ? (
				<UserCard
					userId={cell.row.original.createdBy.id}
					variant="plain"
				/>
			) : null,
		size: 180,
	}),
	createRowActions(RowActions),
];
